import { render, staticRenderFns } from "./ViaggiTrenoArrivi.vue?vue&type=template&id=2fdaee4c"
import script from "./ViaggiTrenoArrivi.vue?vue&type=script&lang=js"
export * from "./ViaggiTrenoArrivi.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports